var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-10 mb-5 text-center" },
    [
      _c("h1", { staticClass: "m-3 mob-h1-font" }, [
        _vm._v("Welcome to " + _vm._s(_vm.site_name))
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "mb-cus-10 mob-h5-font" }, [
        _vm._v("Select your location to start your seasonal lease.")
      ]),
      _vm._v(" "),
      _vm.is_advance_seasonal
        ? [
            _vm._l(_vm.multi_location_list_for_seasonal, function(item, index) {
              return [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-danger m-cus-10",
                    staticStyle: { color: "#fff", "min-width": "100px" },
                    on: {
                      click: function($event) {
                        return _vm.redirectByLink(item.link, item.name)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              ]
            })
          ]
        : [
            _vm._l(_vm.multi_location_list, function(item, index) {
              return [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-danger m-cus-10",
                    staticStyle: { color: "#fff", "min-width": "100px" },
                    on: {
                      click: function($event) {
                        return _vm.redirectByLink(item.link, item.name)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              ]
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }